import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import "./HDImpactTable.css";

const HDImpactMapTable = ({
  selectedGender,
  selectedAgeRange,
  selectedProjectName,
  selectedState,
  selectedDistrict,
  selectedDateRange,

  selectedHomeState,
  selectedHomeDistrict,
  selectedOperatingState,
  selectedOperatingDistrict
}) => {

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ================= FETCH DATA ================= */
  const fetchTableData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        "https://api-sales-insights.haqdarshak.com/api/hd-impact/map-data-with-both-states",
        {
          gender: selectedGender ? [].concat(selectedGender) : [],
          ageRange: selectedAgeRange ? [].concat(selectedAgeRange) : [],
          projectName: selectedProjectName ? [].concat(selectedProjectName) : [],
          state: selectedState ? [].concat(selectedState) : [],
          district: selectedDistrict ? [].concat(selectedDistrict) : [],

          homeState: selectedHomeState ? [].concat(selectedHomeState) : [],
          homeDistrict: selectedHomeDistrict ? [].concat(selectedHomeDistrict) : [],
          operatingState: selectedOperatingState ? [].concat(selectedOperatingState) : [],
          operatingDistrict: selectedOperatingDistrict ? [].concat(selectedOperatingDistrict) : [],

          startDate: selectedDateRange?.start || "",
          endDate: selectedDateRange?.end || ""
        }
      );

      const result = response.data;
      if (Array.isArray(result)) {
        setTableData(result);
      } else {
        setTableData([]);
      }

    } catch (error) {
      console.error("HD Table fetch error:", error);
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTableData();
  }, [
    selectedGender,
    selectedAgeRange,
    selectedProjectName,
    selectedState,
    selectedDistrict,
    selectedDateRange,
    selectedHomeState,
    selectedHomeDistrict,
    selectedOperatingState,
    selectedOperatingDistrict
  ]);

  /* ================= EXPORT EXCEL ================= */
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      tableData.map(d => ({
        "Home State": d.HomeState,
        "Operating State": d.OperatingState,
        "Male HDs Trained": d.maleCount,
        "Female HDs Trained": d.femaleCount,
        "Other HDs Trained": d.othersCount,
        "Total HDs Trained": d.totalCount
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "HD Impact Data");
    XLSX.writeFile(workbook, "hd_impact_data.xlsx");
  };

  /* ================= RENDER ================= */
  return (
    <div className="table-container">
      <button onClick={exportToExcel} className="export-btn">
        Export to Excel
      </button>

      {loading ? (
        <p>Loading table data...</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Home State</th>
              <th>Operating State</th>
              <th>Male HDs Trained</th>
              <th>Female HDs Trained</th>
              <th>Other HDs Trained</th>
              <th>Total HDs Trained</th>
            </tr>
          </thead>

          <tbody>
            {tableData.map((data, index) => (
              <tr key={index}>
                <td>{data.HomeState}</td>
                <td>{data.OperatingState}</td>
                <td>{Number(data.maleCount).toLocaleString()}</td>
                <td>{Number(data.femaleCount).toLocaleString()}</td>
                <td>{Number(data.othersCount).toLocaleString()}</td>
                <td>{Number(data.totalCount).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default HDImpactMapTable;